exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._230czU2NQs4g3JkV1JRj1A .ms-TextField-fieldGroup{min-height:20px!important}html[dir] ._230czU2NQs4g3JkV1JRj1A .ms-TextField-fieldGroup{background-color:transparent}._230czU2NQs4g3JkV1JRj1A .ms-TextField-field{overflow:hidden;line-height:20px}html[dir] ._230czU2NQs4g3JkV1JRj1A .ms-TextField-field{padding:0}._1w8mEAl8Xz_UAG4bU7V5c2{line-height:20px;-webkit-appearance:menulist-textfield;-moz-appearance:textfield}html[dir] ._1w8mEAl8Xz_UAG4bU7V5c2{padding:0}._1ifmLOqBKEXF_olofpCYEN{word-wrap:break-word;word-break:break-word;white-space:pre-wrap}", ""]);

// exports
exports.locals = {
	"editableTitle": "_230czU2NQs4g3JkV1JRj1A",
	"displayTitle": "_1w8mEAl8Xz_UAG4bU7V5c2",
	"titleWrapper": "_1ifmLOqBKEXF_olofpCYEN"
};